import { LoginBackground, MainBackground, MainLogoutIcon, MainSideToggle, MainSmileEmoji, SidebarCompanyLogo, SidebarPointer } from "../../assets/imgs";
import { Box, Button, IconButton, FormControlLabel, Typography, TextField, InputAdornment, Link, outlinedInputClasses, inputLabelClasses, Stack, Pagination, PaginationItem, colors, Grid, MenuItem, Divider, SelectChangeEvent, FormControl, InputLabel, Select, Alert, Collapse } from '@mui/material';
import { alpha, makeStyles, styled, useTheme } from '@mui/material/styles';
import { useState, useContext, useEffect, useRef } from "react";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { DataGrid, GridColDef, GridColumnMenu, GridColumnMenuProps, GridValueGetterParams, gridPageCountSelector, gridPageSelector, gridPaginationSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import TableFooter from '@mui/material/TableFooter';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { blue, red } from "@mui/material/colors";
import PropTypes from 'prop-types';
import React from "react";
import Menu, { MenuProps } from '@mui/material/Menu';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { toBeEnabled } from "@testing-library/jest-dom/matchers";
import { isNullishCoalesce } from "typescript";
import { isDisabled } from "@testing-library/user-event/dist/utils";
import { disconnect } from "process";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import { GlobalStateContext } from '../../store/GlobalState';
import { useNavigate } from "react-router-dom";
import { async } from "q";
import {
    SidebarContainer,
    SidebarContainerItem,
    inactiveStyle,
    NavigationContainer,
    NavigationToggleButton,
    NavigationSideContainer,
    NavigationSideButton,
    CountdownBaseContainer,
    CountdownContainerPaddingStyle,
    BackgroundContainer,
    BigContainer,
    SmallContainer,
    LongContainer,
    ListContainer,
    RemainingContainer,
    NGListContainer,
    ReviseContainer,
    GreenSmallContainer,
    OrangeSmallContainer,
    YellowSmallContainer,
    BlueSmallContainer,
    FourContainer,
    DateContainer,
    DateText,
    Heading,
    ToBeCompleteHeading,
    RemainingWorkHeading,
    ToDoNumber,
    HousingHeading,
    PrivateHeading,
    GreenButton,
    RFIDLink,
    StyledTextField,
} from "../../assets/style"
import ReactLoading from "react-loading";
import { useLazyGetToDoListQuery } from "../../features/toDoList/toDoListApiSlice";
import CloseIcon from '@mui/icons-material/Close';
import TimerIcon from '@mui/icons-material/Timer';

// A Component: CountdownContainer
interface CountdownContainerProps {
    startCountdown: boolean | undefined; // indicates the visibility of this HTML element
    secondsLeftOfCountdown: Number; // the number of seconds shown on this HTML element
}
const CountdownContainer = (props: CountdownContainerProps) => {
    return (
        <CountdownBaseContainer>
            {/* Reference: https://mui.com/material-ui/react-alert/#transition */}
            <Collapse in={props.startCountdown}>
                <Alert
                    icon={<TimerIcon sx={{fontSize: 'calc(12px + 0.35vw)'}} />}
                    style={CountdownContainerPaddingStyle}
                    classes={{
                        root: 'customer-alert-root-padding',
                        message: 'custom-alert-message-padding',
                        icon: 'custom-alert-icon-padding',
                    }}
                >
                    {`Refresh data after : ${props.secondsLeftOfCountdown} s`}
                </Alert>
            </Collapse>
        </CountdownBaseContainer>
    )
}

export default CountdownContainer